import * as actionTypes from '../actionTypes/category';

export function getCategoryData(catID, params, pageCounter) {
    return { type: actionTypes.CATEGORY_DATA_LOAD, categoryId: catID, params, pageCounter };
}

export function getFilterData(categoryId, filterParams) {
    return { type: actionTypes.FILTER_DATA_LOAD, categoryId, filterParams };
}

export function getSearchFilterData(args) {
    return { type: actionTypes.SEARCH_FILTER_LOAD, ...args };
}

export function getSearchCategoryData(params) {
    return { type: actionTypes.SEARCH_CATEGORY_DATA_LOAD, params };
}

export function addFilterData(filterObj) {
    return { type: actionTypes.ADD_FILTERDATA, filterObj };
}

export function handleFilterFunc(func) {
    return { type: actionTypes.HANDLE_FILTER_FUNC, func };
}

export function modifyData(data) {
    return { type: actionTypes.MODIFY_DATA, data };
}

export function loadCatAndFilterData(categoryId, filterParams, pageCounter) {
    return { type: actionTypes.CATEGORY_AND_FILTER_DATA_LOAD, categoryId, filterParams, pageCounter };
}

export function filterDropdown(value) {
    return { type: actionTypes.FILTER_DROPDOWN, value };
}

export function loadScroll({ pathname, categoryId, counter, mystring }) {
    return { type: actionTypes.APPEND_DATA_LOAD, pathname, categoryId, counter, mystring };
}

export function debouceCategoryDataOnScroll(categoryInfo) {
    return { type: actionTypes.DEBOUNCE_CATEGORY_DATA_ON_SCROLL, ...categoryInfo };
}

export function showCachedCategoryData(categoryInfo) {
    return { type: actionTypes.SHOW_CACHED_DATA, data: { ...categoryInfo } };
}

export function updateDittoEnable(value) {
    return { type: actionTypes.UPDATE_DITTO_ENABLE, value };
}

export function unsetFilterState() {
    return { type: actionTypes.FILTER_STATE_UNSET };
}

export function loadSubCategory(data) {
    return { type: actionTypes.SUBCATEGORY_DATA_LOAD, data };
}
